export default __webpack_public_path__ + "static/dami_image-c94a90d1691c295fa65d56ffbf7df465.png";